import type * as THREE from "three";
import type { EffectComposer, EffectComposerPassInterface } from "./effectComposerTypes";
import { effectComposerSetSize } from "./effectComposerTypes";

export abstract class EffectComposerPass implements EffectComposerPassInterface {
  enabled: boolean = true;

  childEffects?: EffectComposer;

  constructor() {}

  setSize(width: number, height: number): void {
    if (this.childEffects) {
      effectComposerSetSize(this.childEffects, width, height);
    }
  }

  setSizeWithPixelRatio(width: number, height: number, pixelRatio: number): void {
    const effectiveWidth = Math.floor(width * pixelRatio);
    const effectiveHeight = Math.floor(height * pixelRatio);
    this.setSize(effectiveWidth, effectiveHeight);
  }

  abstract render(renderer: THREE.WebGLRenderer, writeBuffer: THREE.WebGLRenderTarget | null): void;
}
